import { getCookie } from '../auth/cookie';
import type { OptimizelyInstance } from './types';

let optimizelyInstance: OptimizelyInstance;

async function initializeOptimizelyClientInstance() {
  // Ensure client has opted in to use Optimizely
  if (!window.optimizelySdk || !window.optimizelyDatafile) return null;

  optimizelyInstance = window.optimizelySdk.createInstance({
    datafile: window.optimizelyDatafile,
  }) as OptimizelyInstance;

  await optimizelyInstance.onReady({ timeout: 150 });
}

function getLoginButtonVariant() {
  if (optimizelyInstance) {
    const userId = getCookie('optuid');
    if (!userId) return 'login_button_and_tv2_play_link';
    const variant = optimizelyInstance.activate('new_login_button', userId);
    return variant;
  }
}

function trackLoginButtonClick() {
  if (optimizelyInstance) {
    const userId = getCookie('optuid');
    if (userId) {
      optimizelyInstance.track('clicked_login_button', userId);
    }
  }
}

export {
  initializeOptimizelyClientInstance,
  getLoginButtonVariant,
  trackLoginButtonClick,
};
